/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
    var owl = $('.owl-carousel');
    owl.owlCarousel({
        autoWidth: false,
        autoplay: true,
        items: 7,
        loop: true,
        margin: 20,
        merge: true,
        autoplayHoverPause: true,
        slideTransition: 'linear',
        autoplaySpeed: 5000,
        nav: false,
        dots: false,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: false
            },
            240: {
                items: 2,
                nav: false,
                dots: false
            },
            320: {
                items: 3,
                nav: false,
                dots: false
            },
            480: {
                items: 4,
                nav: false,
                dots: false
            },
            768: {
                items: 6,
                nav: false,
                dots: false
            },
            1024: {
                items: 6,
                nav: false,
                dots: false
            }
        }
    });
    $('.play').on('click', function () {
        owl.trigger('play.owl.autoplay', [1000])
    });
    $('.stop').on('click', function () {
        owl.trigger('stop.owl.autoplay')
    });
  
//    $(".product-inquery-form span").click(function() {
//   $(".product-inquery-form-main").fadeIn(500);
//     $("body").addClass("product-inquery-form-body");
// });
// $(".close").click(function() {
//   $(".product-inquery-form-main").fadeOut(500);
//    $("body").removeClass("product-inquery-form-body");
// });


// Open the Quote / Inquiry popup
// $(document).on("click", ".js-open-inquiry", function (e) {
//     e.preventDefault(); // stop navigation / form submit
//     $(".product-inquery-form-main").fadeIn(500);
//     $("body").addClass("product-inquery-form-body");
//   });
  
  //   // Close the popup
  //   $(document).on("click", ".close", function (e) {
  //     e.preventDefault();
  //     $(".product-inquery-form-main").fadeOut(500);
  //     $("body").removeClass("product-inquery-form-body");
  //   });

  //   $('.product-special-order span').click(function () {
  //     $('.product-inquery-popup').addClass('open-popup-main');
  //     $('body').addClass('open-popup-main-area');
  //   });
  //   $('.product-inquery-popup-close').click(function() {
  //     $('.product-inquery-popup').removeClass('open-popup-main');
  //     $('body').removeClass('open-popup-main-area');
  //   });

});

// // Open the same inquiry popup the Quote button uses
// $(document).on('click', '.js-open-inquiry', function (e) {
//   e.preventDefault();
//   $('.product-inquery-form-main').fadeIn(300);
//   $('body').addClass('product-inquery-form-body');
// });

// // (Optional) close safety if you need it here too
// $(document).on('click', '.product-inquery-form-main .close', function (e) {
//   e.preventDefault();
//   $('.product-inquery-form-main').fadeOut(300);
//   $('body').removeClass('product-inquery-form-body');
// });



jQuery(document).ready(function ($) {
  $('.logo-slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } }
    ]
  });
});

jQuery(document).ready(function ($) {
  $('.logo-slider-new').slick({
    slidesToShow: 11,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } }
    ]
  });
});

jQuery(document).ready(function ($) {
  $('.blog_slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
   //speed: 50000,
   
    infinite: true,
    arrows: true,
    dots: false,
      responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow:1
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1
            }
          }
        ]
  });
});


// faq

  document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-item');

    // 👉 First FAQ open by default
    if (faqItems.length > 0) {
      faqItems[0].classList.add('active');
    }

    faqItems.forEach(item => {
      const button = item.querySelector('.faq-question');

      button.addEventListener('click', () => {
        // 👉 Close all FAQs
        faqItems.forEach(i => {
          if (i !== item) {
            i.classList.remove('active');
          }
        });

        // 👉 Toggle current FAQ
        item.classList.toggle('active');
      });
    });
  });

// collection list slider
  // document.addEventListener('DOMContentLoaded', function () {
  //   if (window.jQuery && $('.collection-list').length) {
  //     $('.collection-list').slick({
  //       slidesToShow: 4,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       dots: false,
  //       infinite: false,
  //       autoplay: false,
  //       responsive: [
  //         {
  //           breakpoint: 1024,
  //           settings: {
  //             slidesToShow: 3
  //           }
  //         },
  //         {
  //           breakpoint: 768,
  //           settings: {
  //             slidesToShow: 2
  //           }
  //         },
  //         {
  //           breakpoint: 480,
  //           settings: {
  //             slidesToShow: 1
  //           }
  //         }
  //       ]
  //     });
  //   }
  // });



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".slick-slide").forEach(function (slide) {
    if (slide.innerHTML.trim() === "") {
      slide.remove();
    }
  });
});


// header sticky 

$(window).scroll(function () {
  if ($(this).scrollTop() > 100) {
    $(".header_sticky").addClass("sticky");
  } else {
    $(".header_sticky").removeClass("sticky");
  }
});


//a removed
document.querySelectorAll('.main_logo_slider2 a').forEach(function(a){
  a.replaceWith(...a.childNodes);
});

document.querySelectorAll('.image_text_main a').forEach(function(a){
  a.replaceWith(...a.childNodes);
});













/**
CUSTOM JS CODE AKHTAR
*/

$(document).ready(function () {

  /**
   * Product main page:
   * Open special order popup instead of normal add to cart.
   */
  $(document).on('click', '.open-special-order-modal', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    $('.product-inquery-popup').addClass('open-popup-main');
    $('body').addClass('open-popup-main-area');
  });

  /**
   * Close product main page popup.
   */
  $(document).on('click', '.product-inquery-popup-close', function (e) {
    e.preventDefault();

    $('.product-inquery-popup').removeClass('open-popup-main');
    $('body').removeClass('open-popup-main-area');
  });

  /**
   * Product main page:
   * Add to cart from popup.
   */
  $(document).on('click', '.confirm-special-order', function (e) {
    e.preventDefault();

    const variantId = $(this).data('variant-id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then((res) => {
      if (res.ok) {
        $('.product-inquery-popup').removeClass('open-popup-main');
        $('body').removeClass('open-popup-main-area');

        document.documentElement.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: { quantity: 1 }
          })
        );
      } else {
        alert('Error adding product to cart.');
      }
    })
    .catch((err) => {
      console.error(err);
      alert('Something went wrong. Try again.');
    });
  });

  /**
   * Collection / featured collection:
   * Open special order popup.
   */
  $(document).on('click', '.custom-open-special-order-modal', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const variantId = $(this).data('variant-id');
    const image = $(this).data('product-image');
    const title = $(this).data('product-title');

    $('.custom-confirm-special-order').attr('data-variant-id', variantId);
    $('.special-order-product-image').attr('src', image);
    $('.special-order-product-title').text(title);

    const $popup = $('.custom-product-inquery-popup');
    $popup.css('display', 'block');
    $popup.fadeIn(100);

    $('html, body').addClass('custom-lock-scroll');

    setTimeout(() => {
      if ($popup.length) {
        $popup[0].scrollTop = 0;
      }
    }, 20);
  });

  /**
   * Close collection popup.
   */
  $(document).on('click', '.custom-product-inquery-popup-close', function (e) {
    e.preventDefault();

    $('.custom-product-inquery-popup').fadeOut(200);
    $('html, body').removeClass('custom-lock-scroll');
  });

  /**
   * Collection / featured collection:
   * Add to cart from popup.
   */
  $(document).on('click', '.custom-confirm-special-order', function (e) {
    e.preventDefault();

    const variantId = $(this).data('variant-id');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => {
      if (res.ok) {
        $('.custom-product-inquery-popup').fadeOut(200);
        $('html, body').removeClass('custom-lock-scroll');

        document.documentElement.dispatchEvent(
          new CustomEvent('product:added', {
            bubbles: true,
            detail: { quantity: 1 }
          })
        );
      } else {
        alert('Error adding product to cart.');
      }
    })
    .catch(err => {
      console.error('Error:', err);
      alert('Something went wrong. Try again.');
    });
  });

});